export const getBreakpoint = function (name)
{
  switch (name) {
    case 'xs':
      return 360;
    case 'sm':
      return 480;
    case 'md':
      return 768;
    case 'lg':
      return 1024;
    case 'xl':
      return 1248;
    case '2xl':
      return 1440;
    default:
      return 0;
  }
}
